class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();

    // Nothing opens on add to cart. Razorpay handles the cart, and the drawer
    // is there for anyone who taps the cart icon, so this popup only got in
    // the way. The sections above are still re-rendered, so the header count
    // updates and the notification is current if anything ever opens it.
    // cart-drawer.js has the same treatment at the end of its renderContents.
    //
    // Left as a setting-independent change on purpose: Shopify's Cart type
    // offers only drawer, page or notification, with no "none", and switching
    // to page would remove the cart element entirely and make Dawn's product
    // form redirect to /cart on every add.
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

/* Razorpay Sidecart: open from the cart icon, not from add to cart
   ----------------------------------------------------------------------
   Sidecart opens itself on every add. Razorpay exposes no setting for this -
   its sidecartConfig metafield carries only isEnabled, which is all-or-nothing
   and would also remove it from the cart icon - so it is gated here instead.

   RazorpayCart is global but the plugin keeps its instance in a closure, so
   the gate goes on the prototype. Every open is refused unless something has
   just marked it allowed: a click on the cart icon, or being on the cart page,
   which Sidecart renders in place of Dawn's.

   The listener is on window in the capture phase so it runs before Sidecart's
   own handlers, whenever they were registered. The plugin script is deferred
   and sits at the end of the body, so RazorpayCart does not exist yet when
   this file runs - hence the short poll rather than a straight patch. */
(function () {
  var DEADLINE = Date.now() + 15000;

  function allow() {
    window.__rzpSidecartAllowOpen = true;
  }

  // The cart page is Sidecart's own; refusing there would leave it blank.
  if (window.location.pathname.replace(/\/$/, '').endsWith('/cart')) allow();

  window.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (target && target.closest && target.closest('#cart-icon-bubble')) allow();
    },
    true
  );

  function patch() {
    var Cart = window.RazorpayCart;
    if (!Cart || !Cart.prototype || typeof Cart.prototype.open !== 'function') {
      if (Date.now() < DEADLINE) setTimeout(patch, 200);
      return;
    }
    if (Cart.prototype.__charmdGated) return;

    var original = Cart.prototype.open;
    Cart.prototype.open = function () {
      if (!window.__rzpSidecartAllowOpen) return;
      window.__rzpSidecartAllowOpen = false;
      return original.apply(this, arguments);
    };
    Cart.prototype.__charmdGated = true;
  }

  patch();
})();
